import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"
import { uiColorToBaseColor } from "styleguide/styles/colors"

const IconArrowRight = ({
  title = "Arrow right",
  color = "darkerRed",
  viewBoxWidth = 24,
  viewBoxHeight = 16,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, color, ...otherProps }}>
    <g fill="none" fillRule="evenodd">
      <path d="M-322-1076h1440v3236H-322z" />
      <path
        d="M0 7h20l-5.5-5.5L16 0l7 7 1 1-1 1-7 7-1.5-1.5L20 9H0z"
        fill={uiColorToBaseColor(color)}
      />
    </g>
  </Svg.Icon>
)

export default IconArrowRight
